import { pCore } from './.catalog';

export default class pUiVersionKontrol extends pCore {
    constructor(options: {
        VersiyonIsmi: string;
        VersiyonKodu: number;
        IsletimSistemiAdi: string;
    }) {
        super();
        this.VersiyonIsmi = options.VersiyonIsmi;
        this.VersiyonKodu = options.VersiyonKodu;
        this.IsletimSistemiAdi = options.IsletimSistemiAdi;
    }
    public VersiyonIsmi: string = '0';
    public VersiyonKodu: number = 0;
    public IsletimSistemiAdi: string = "";
}
